import { createFileRoute } from "@tanstack/react-router";
import { enPhotoRoute } from "@/lib/seo/enPhotoRoute";

export const Route = createFileRoute("/en_/photography/product-photography")(
  enPhotoRoute("/en/photography/product-photography"),
);
